import React, { useState, useEffect, Fragment } from 'react';
import { getGroupID } from '../../../../../../helpers/AxiosAPI';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
const CodeSnippet = ({ propertyId, integrationId, serviceProvider }) => {
  const [code, setCodeSnippet] = useState();
  useEffect(() => {
    if (serviceProvider !== undefined) {
      if (serviceProvider == 1) {
        setCodeSnippet(`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
        <OfficeApp xmlns="http://schemas.microsoft.com/office/appforoffice/1.1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bt="http://schemas.microsoft.com/office/officeappbasictypes/1.0" xmlns:mailappor="http://schemas.microsoft.com/office/mailappversionoverrides/1.0" xsi:type="MailApp">
          <Id>5a662364-1930-4e82-9283-f64dec662bc1</Id>
          <Version>1.0.0.0</Version>
          <ProviderName>Myma.ai</ProviderName>
          <DefaultLocale>en-US</DefaultLocale>
          <DisplayName DefaultValue="Myma.ai Email Assistant"/>
          <Description DefaultValue="Speed up email responses combining the power of Gen AI and APIs"/>
          <IconUrl DefaultValue="https://assets.bookmebob.com/bmbgallery/42593f2a-de79-4284-8673-b1600142254d/c3f9456e-50bb-4388-9989-7a284b6be519.png"/>
          <HighResolutionIconUrl DefaultValue="https://assets.bookmebob.com/bmbgallery/42593f2a-de79-4284-8673-b1600142254d/c3f9456e-50bb-4388-9989-7a284b6be519.png"/>
          <SupportUrl DefaultValue="${
            process.env.REACT_APP_MYMA_EMAIL_PLUGIN
          }/help"/>
          <AppDomains>
            <AppDomain>${process.env.REACT_APP_MYMA_EMAIL_PLUGIN}</AppDomain>
          </AppDomains>
          <Hosts>
            <Host Name="Mailbox"/>
          </Hosts>
          <Requirements>
            <Sets>
              <Set Name="Mailbox" MinVersion="1.1"/>
            </Sets>
          </Requirements>
          <FormSettings>
            <Form xsi:type="ItemRead">
              <DesktopSettings>
                <SourceLocation DefaultValue="${
                  process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                }/taskpane.html"/>
                <RequestedHeight>250</RequestedHeight>
              </DesktopSettings>
            </Form>
          </FormSettings>
          <Permissions>ReadWriteItem</Permissions>
          <Rule xsi:type="RuleCollection" Mode="Or">
            <Rule xsi:type="ItemIs" ItemType="Message" FormType="Read"/>
          </Rule>
          <VersionOverrides xmlns="http://schemas.microsoft.com/office/mailappversionoverrides" xsi:type="VersionOverridesV1_0">
            <VersionOverrides xmlns="http://schemas.microsoft.com/office/mailappversionoverrides/1.1" xsi:type="VersionOverridesV1_1">
              <Requirements>
                <bt:Sets DefaultMinVersion="1.3">
                  <bt:Set Name="Mailbox"/>
                </bt:Sets>
              </Requirements>
              <Hosts>
                <Host xsi:type="MailHost">
                  <DesktopFormFactor>
                    <FunctionFile resid="Commands.Url"/>
                    <ExtensionPoint xsi:type="MessageReadCommandSurface">
                      <OfficeTab id="TabDefault">
                        <Group id="msgComposeGroup">
                          <Label resid="GroupLabel"/>
                          <Control xsi:type="Button" id="msgReadOpenPaneButton">
                            <Label resid="paneReadButtonLabel"/>
                            <Supertip>
                              <Title resid="paneReadButtonLabel"/>
                              <Description resid="TaskpaneButton.Tooltip"/>
                            </Supertip>
                            <Icon>
                              <bt:Image size="16" resid="Icon.16x16"/>
                              <bt:Image size="32" resid="Icon.32x32"/>
                              <bt:Image size="80" resid="Icon.80x80"/>
                            </Icon>
                            <Action xsi:type="ShowTaskpane">
                              <SourceLocation resid="Taskpane.Url"/>
                              <SupportsPinning>true</SupportsPinning>
                            </Action>
                          </Control>
                        </Group>
                      </OfficeTab>
                    </ExtensionPoint>                
                  </DesktopFormFactor>
                </Host>  
                <Host xsi:type="MailHost">
                  <DesktopFormFactor>
                    <FunctionFile resid="Commands.Url"/>
                    <ExtensionPoint xsi:type="MessageComposeCommandSurface">
                      <OfficeTab id="TabDefault1">
                        <Group id="msg1ComposeGroup">
                          <Label resid="GroupLabel"/>
                          <Control xsi:type="Button" id="msgComposeOpenPaneButton1">
                            <Label resid="TaskpaneButton1.Label"/>
                            <Supertip>
                              <Title resid="TaskpaneButton1.Label"/>
                              <Description resid="TaskpaneButton1.Tooltip"/>
                            </Supertip>
                            <Icon>
                              <bt:Image size="16" resid="Icon.16x16"/>
                              <bt:Image size="32" resid="Icon.32x32"/>
                              <bt:Image size="80" resid="Icon.80x80"/>
                            </Icon>
                            <Action xsi:type="ShowTaskpane">
                              <SourceLocation resid="Taskpane.Url"/>
                            </Action>
                          </Control>                                 
                        </Group>
                      </OfficeTab>
                    </ExtensionPoint>    
                  </DesktopFormFactor>
                </Host> 
              </Hosts>
              <Resources>
                <bt:Images>
                  <bt:Image id="Icon.16x16" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/assets/icon-16.png"/>
                  <bt:Image id="Icon.32x32" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/assets/icon-32.png"/>
                  <bt:Image id="Icon.80x80" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/assets/icon-80.png"/>
                </bt:Images>
                <bt:Urls>
                  <bt:Url id="Commands.Url" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/commands.html"/>
                  <bt:Url id="Taskpane.Url" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/taskpane.html?gid=${getGroupID()}_iid=${integrationId}_pid=${propertyId}_"/>
                  <bt:Url id="readTaskPaneUrl" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/taskpane.html?gid=${getGroupID()}_iid=${integrationId}_pid=${propertyId}_"/>
                </bt:Urls>
                <bt:ShortStrings>
                  <bt:String id="GroupLabel" DefaultValue="Contoso Add-in"/>
                  <bt:String id="TaskpaneButton.Label" DefaultValue="Myma.ai Email Assistant"/>
                  <bt:String id="paneReadButtonLabel" DefaultValue="Myma.ai Email Assistant"/>
                  <bt:String id="ActionButton.Label" DefaultValue="Myma.ai Email Assistant"/>
                </bt:ShortStrings>
                <bt:LongStrings>
                  <bt:String id="TaskpaneButton.Tooltip" DefaultValue="Speed up email responses combining the power of Gen AI and APIs"/>
                  <bt:String id="TaskpaneButton1.Tooltip" DefaultValue="Speed up email responses combining the power of Gen AI and APIs"/>
                  <bt:String id="ActionButton.Tooltip" DefaultValue="Speed up email responses combining the power of Gen AI and APIs"/>
                </bt:LongStrings>
              </Resources>
            <!-- Configures the prepend-on-send and append-on-send features. The same value, AppendOnSend, is used for both features. -->
            <ExtendedPermissions>
              <ExtendedPermission>AppendOnSend</ExtendedPermission>
            </ExtendedPermissions>
            </VersionOverrides>
          </VersionOverrides>
        </OfficeApp>`);
      } else if (serviceProvider == 2) {
        setCodeSnippet(`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
        <OfficeApp xmlns="http://schemas.microsoft.com/office/appforoffice/1.1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bt="http://schemas.microsoft.com/office/officeappbasictypes/1.0" xmlns:mailappor="http://schemas.microsoft.com/office/mailappversionoverrides/1.0" xsi:type="MailApp">
          <Id>5a662364-1930-4e82-9283-f64dec662bc1</Id>
          <Version>1.0.0.0</Version>
          <ProviderName>Sabre</ProviderName>
          <DefaultLocale>en-US</DefaultLocale>
          <DisplayName DefaultValue="AI Email Assistant for Hospitality"/>
          <Description DefaultValue="Speed up email responses combining the power of Gen AI and Sabre APIs"/>
          <IconUrl DefaultValue="https://assets.bookmebob.com/bmbgallery/5b6d74fd-0f10-40c9-af73-b24a007142d0/9d61e5c1-bb0f-4c34-b4f6-564eac736f9b.png"/>
          <HighResolutionIconUrl DefaultValue="https://assets.bookmebob.com/bmbgallery/5b6d74fd-0f10-40c9-af73-b24a007142d0/9d61e5c1-bb0f-4c34-b4f6-564eac736f9b.png"/>
          <SupportUrl DefaultValue="${
            process.env.REACT_APP_MYMA_EMAIL_PLUGIN
          }/help"/>
          <AppDomains>
            <AppDomain>${process.env.REACT_APP_MYMA_EMAIL_PLUGIN}</AppDomain>
          </AppDomains>
          <Hosts>
            <Host Name="Mailbox"/>
          </Hosts>
          <Requirements>
            <Sets>
              <Set Name="Mailbox" MinVersion="1.1"/>
            </Sets>
          </Requirements>
          <FormSettings>
            <Form xsi:type="ItemRead">
              <DesktopSettings>
                <SourceLocation DefaultValue="${
                  process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                }/taskpane.html"/>
                <RequestedHeight>250</RequestedHeight>
              </DesktopSettings>
            </Form>
          </FormSettings>
          <Permissions>ReadWriteItem</Permissions>
          <Rule xsi:type="RuleCollection" Mode="Or">
            <Rule xsi:type="ItemIs" ItemType="Message" FormType="Read"/>
          </Rule>
          <VersionOverrides xmlns="http://schemas.microsoft.com/office/mailappversionoverrides" xsi:type="VersionOverridesV1_0">
            <VersionOverrides xmlns="http://schemas.microsoft.com/office/mailappversionoverrides/1.1" xsi:type="VersionOverridesV1_1">
              <Requirements>
                <bt:Sets DefaultMinVersion="1.3">
                  <bt:Set Name="Mailbox"/>
                </bt:Sets>
              </Requirements>
              <Hosts>
                <Host xsi:type="MailHost">
                  <DesktopFormFactor>
                    <FunctionFile resid="Commands.Url"/>
                    <ExtensionPoint xsi:type="MessageReadCommandSurface">
                      <OfficeTab id="TabDefault">
                        <Group id="msgComposeGroup">
                          <Label resid="GroupLabel"/>
                          <Control xsi:type="Button" id="msgReadOpenPaneButton">
                            <Label resid="paneReadButtonLabel"/>
                            <Supertip>
                              <Title resid="paneReadButtonLabel"/>
                              <Description resid="TaskpaneButton.Tooltip"/>
                            </Supertip>
                            <Icon>
                              <bt:Image size="16" resid="Icon.16x16"/>
                              <bt:Image size="32" resid="Icon.32x32"/>
                              <bt:Image size="80" resid="Icon.80x80"/>
                            </Icon>
                            <Action xsi:type="ShowTaskpane">
                              <SourceLocation resid="Taskpane.Url"/>
                              <SupportsPinning>true</SupportsPinning>
                            </Action>
                          </Control>
                        </Group>
                      </OfficeTab>
                    </ExtensionPoint>                
                  </DesktopFormFactor>
                </Host>  
                <Host xsi:type="MailHost">
                  <DesktopFormFactor>
                    <FunctionFile resid="Commands.Url"/>
                    <ExtensionPoint xsi:type="MessageComposeCommandSurface">
                      <OfficeTab id="TabDefault1">
                        <Group id="msg1ComposeGroup">
                          <Label resid="GroupLabel"/>
                          <Control xsi:type="Button" id="msgComposeOpenPaneButton1">
                            <Label resid="TaskpaneButton1.Label"/>
                            <Supertip>
                              <Title resid="TaskpaneButton1.Label"/>
                              <Description resid="TaskpaneButton1.Tooltip"/>
                            </Supertip>
                            <Icon>
                              <bt:Image size="16" resid="Icon.16x16"/>
                              <bt:Image size="32" resid="Icon.32x32"/>
                              <bt:Image size="80" resid="Icon.80x80"/>
                            </Icon>
                            <Action xsi:type="ShowTaskpane">
                              <SourceLocation resid="Taskpane.Url"/>
                            </Action>
                          </Control>                                 
                        </Group>
                      </OfficeTab>
                    </ExtensionPoint>    
                  </DesktopFormFactor>
                </Host> 
              </Hosts>
              <Resources>
                <bt:Images>
                  <bt:Image id="Icon.16x16" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/assets/icon-16.png"/>
                  <bt:Image id="Icon.32x32" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/assets/icon-32.png"/>
                  <bt:Image id="Icon.80x80" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/assets/icon-80.png"/>
                </bt:Images>
                <bt:Urls>
                  <bt:Url id="Commands.Url" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/commands.html"/>
                  <bt:Url id="Taskpane.Url" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/taskpane.html?gid=${getGroupID()}_iid=${integrationId}_pid=${propertyId}_"/>
                  <bt:Url id="readTaskPaneUrl" DefaultValue="${
                    process.env.REACT_APP_MYMA_EMAIL_PLUGIN
                  }/taskpane.html?gid=${getGroupID()}_iid=${integrationId}_pid=${propertyId}_"/>
                </bt:Urls>
                <bt:ShortStrings>
                  <bt:String id="GroupLabel" DefaultValue="Contoso Add-in"/>
                  <bt:String id="TaskpaneButton.Label" DefaultValue="Sabre"/>
                  <bt:String id="paneReadButtonLabel" DefaultValue="Sabre"/>
                  <bt:String id="ActionButton.Label" DefaultValue="Sabre"/>
                </bt:ShortStrings>
                <bt:LongStrings>
                  <bt:String id="TaskpaneButton.Tooltip" DefaultValue="AI Email Assistant for Hospitality"/>
                  <bt:String id="TaskpaneButton1.Tooltip" DefaultValue="AI Email Assistant for Hospitality"/>
                  <bt:String id="ActionButton.Tooltip" DefaultValue="AI Email Assistant for Hospitality"/>
                </bt:LongStrings>
              </Resources>
            <!-- Configures the prepend-on-send and append-on-send features. The same value, AppendOnSend, is used for both features. -->
            <ExtendedPermissions>
              <ExtendedPermission>AppendOnSend</ExtendedPermission>
            </ExtendedPermissions>
            </VersionOverrides>
          </VersionOverrides>
        </OfficeApp>`);
      }
    }
  }, [serviceProvider]);

  const handleDownload = () => {
    var filename = 'manifest.xml';
    var pom = document.createElement('a');
    var bb = new Blob([code], { type: 'text/xml' });

    pom.setAttribute('href', window.URL.createObjectURL(bb));
    pom.setAttribute('download', filename);

    pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
    pom.draggable = true;
    pom.classList.add('dragout');

    pom.click();
  };
  return (
    <Fragment>
      <Button
        color="primary"
        size="xs"
        outline
        onClick={() => handleDownload()}
      >
        <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon> Download
        manifest.xml
      </Button>
    </Fragment>
  );
};

export default CodeSnippet;
